export const SET_MEMBER = 'dashboard/SET_MEMBER';
export const OPEN_RECENT_SEARCH_FLYOUT = 'dashboard/OPEN_RECENT_SEARCH_FLYOUT';
export const SET_RECENT_SEARCH = 'dashboard/SET_RECENT_SEARCH';
export const LOAD_RECENT_SEARCHES = 'dashboard/LOAD_RECENT_SEARCHES';
export const CLEAR_RECENT_SEARCHES = 'dashboard/CLEAR_RECENT_SEARCHES';
export const TOGGLE_OON_WIDGET = 'dashboard/TOGGLE_OON_WIDGET';
export const SET_SELECTED_PROVIDER_PLN = 'dashboard/SET_SELECTED_PROVIDER_PLN';
export const SET_CLAIMS_CRITERIA = 'dashboard/SET_CLAIMS_CRITERIA';
export const SET_ELIGIBILITY_CRITERIA = 'dashboard/SET_ELIGIBILITY_CRITERIA';
export const SET_REFERRAL_CRITERIA = 'dashboard/SET_REFERRAL_CRITERIA';
export const OPEN_TRACKIT_FLYOUT = 'dashboard/OPEN_TRACKIT_FLYOUT';
export const SEARCH_CURRENT_MEMBER = 'dashboard/SEARCH_CURRENT_MEMBER';
export const DOCLIB_ADV_SEARCH_FLYOUT = 'dashboard/DOCLIB_ADV_SEARCH_FLYOUT';
export const PROVIDER_PREFERENCE_ERROR = 'dashboard/PROVIDER_PREFERENCE_ERROR';
export const SET_VIEWED_PROVIDER_CHAT_MODAL =
  'dashboard/SET_VIEWED_PROVIDER_CHAT_MODAL';
export const PROVIDER_PREFERENCE_COMPLETE =
  'dashboard/PROVIDER_PREFERENCE_COMPLETE';
